import { useEffect, useState } from "react";
import { useAuth } from "../AuthProvider";
import { baseUrl_SPB } from "../BaseUrl";
import { fetchAuthSession } from "aws-amplify/auth";

export default function PurchaseRequestSuccess(props) {
    const authContext = useAuth();
    const [session_id, setSession_id] = useState('');
    useEffect(() => {
        async function completeSubscriptionProcess() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const paramValue = urlParams.get('session_id');
            console.log("I am inside");
            console.log(paramValue);
            const data = paramValue;
            fetchAuthSession().then((session) => {
                console.log("HERE CHANGED INSIDE PURCHAS");
                let tokenv = session.tokens.accessToken.toString();
                console.log(tokenv);
                fetch(`${baseUrl_SPB}/api/v1/subscribe/postpurchasesuccess`, {

                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + tokenv,

                    },
                    body: data
                }).then(response => response.json())
                    .then(data => {
                        console.log('Success:', data);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });

            });
        }
        completeSubscriptionProcess();
        //const jsonResponse = await response.json();
        //console.log(jsonResponse);
    }, [session_id]);
    return (
        <div>
            <h1>Thank you for your purchase!{session_id}</h1>
            <p>Your order is being processed.</p>
        </div>
    );
}